import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { iValidatedControl } from '../../../../../apps/swipesumportal-app/src/app/components/ui/controls/iValidatedControl';
import { BaseCustomControl } from '../baseCustomControl';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Radio),
      multi: true,
    },
  ],
})
export class Radio extends BaseCustomControl implements ControlValueAccessor, iValidatedControl {
  @Input() checked: boolean = false;
  @Input() label: string = '';
  @Input() displayDirection: string = 'horizontal'; // horizontal | vertical
  @Input() progressTracker: boolean = false;
  @Input() name: string = '';

  @Output() onChanged = new EventEmitter<any>();

  override clear() {
  }

  validate(): boolean {
    return true;
  }

  handleOnChanged(event: any) {
    this.onChanged.emit(event);
  }
}
